import * as React from "react";
import {Modal, FormGroup} from "react-bootstrap";
import { Alert } from "../ui/form/Alert";

interface Props { 
    show?: boolean,
    okLabel: string,
    cancelLabel?: string,
    heading: string,
    description?: string, 
    okClassName?: string,
    cancelClassName?: string,
    hideCancelButton? : boolean,
    hideOkButton? : boolean,
    onOk: () => void, 
    onCancel?: () => void,
    disableActions?: boolean
}

export class ErrorModal extends React.Component<Props, {}>{

    async onCancel() {
        if (this.props.onCancel) {
            this.props.onCancel();
        }
    }

    async doOk() {
        this.props.onOk();
    }

    getActions() {
        let btnCancelClass = this.props.cancelClassName ? this.props.cancelClassName : "btn-primary";
        let btnClass = this.props.okClassName ? this.props.okClassName : "btn-danger";
        let btnCancel = this.props.cancelLabel ? this.props.cancelLabel : "Cancel";
        let hideCancelButton = this.props.hideCancelButton ? this.props.hideCancelButton : false;
        let hideOkButton = this.props.hideOkButton ? this.props.hideOkButton : false;
        return (
            <FormGroup className="form-group">
                <div> 
                    {!hideCancelButton && 
                        ( <a href="/#"  className={`btn ${btnCancelClass}`} onClick={(e)=>{ e.preventDefault(); this.onCancel.bind(this)}}>{btnCancel}</a>)
                    }
                    {!hideOkButton && 
                        ( <a  href="/#" className={`btn ${btnClass}`} onClick={(e)=>{ e.preventDefault(); this.doOk.bind(this)}}>{this.props.okLabel}</a>)
                    }
                </div>
            </FormGroup>
        );
    }

    render() {
        return (
            <Modal show={this.props.show} onHide={this.onCancel.bind(this)} aria-labelledby="contained-modal-title">
                <Modal.Header  closeButton>
                    <Modal.Title id="contained-modal-title">{this.props.heading}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Alert type="danger" text={this.props.description} />
                </Modal.Body>
                {
                    (this.props.disableActions===undefined || this.props.disableActions===false) && (
                    <Modal.Footer>
                        {this.getActions()}
                    </Modal.Footer>
                    )
                }
                
            </Modal>
       );
    }
}